import React from 'react';
import en from '../../data/localization/en';


const Localization = (componentName, WrappedComponent) => (props) => {
    const selectedLanguage = en
    return (<WrappedComponent {...props} locale={selectedLanguage[componentName]} />);
}

export default Localization;